// @react
import React from 'react'
// @types
import {
  GetConstantsQuery,
  GetConstantsQueryVariables,
  GetUserQuery,
  GetUserQueryVariables,
} from 'lib/graphql/graphqlTypes'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
import { GET_CONSTANTS } from 'graphql/queries/constants.query'
// @module components
import JobForm from './Form/index'
import QueryError from 'modules/common/components/Errors/QueryError'

/**
 * @todo what section ID is this?
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3123%3A16072
 *
 * userIndustry
 * industry
 * jobFunctionCode

 * jobTitle
 * companySize
 * trainingBudget
 * directReportCount
 *
 */

type PropsType = any

const Job = ({ props }: PropsType, ref: React.Ref<HTMLDivElement>) => {
  /****************************************
   *  GQL HOOKS
   ****************************************/

  const {
    loading: isUserLoading,
    error: isUserError,
    data: userData,
  } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  const {
    loading: isConstantsLoading,
    error: isConstantsError,
    data: constantsData,
  } = useQuery<GetConstantsQuery, GetConstantsQueryVariables>(GET_CONSTANTS, {
    fetchPolicy: 'cache-first',
  })

  /****************************************
   *  RENDER
   ****************************************/

  const isLoading = isUserLoading || isConstantsLoading

  if (
    isUserError ||
    isConstantsError ||
    (!isLoading && (!userData || !constantsData))
  )
    return <QueryError />

  return (
    <div ref={ref}>
      <JobForm
        data={userData}
        constants={constantsData}
        isLoading={isLoading}
      />
    </div>
  )
}

export default React.forwardRef<HTMLDivElement>(Job)
